import React from 'react';
import PropTypes from 'prop-types';
import logo from '../../image/logo.png';
import Ellipse from '../../image/Ellipse.png';
import { getUser, logout } from 'redux/features/userSliceWithTokenValidation';
import { rxdApi } from 'actions/rtkquery';
import { persistor } from 'redux/store';
import { useDispatch, useSelector } from 'react-redux';
import Logout from '../../image/log-out.png';
import Bell from '../../image/bell.png';
import Param from '../../image/Group 101987.png';
import { useNavigate, useParams } from 'react-router-dom';
import { LOGIN_PATH, PARAMETRES_CABINET } from 'routes/navigation/navigationPaths';
import { NavDropdown } from 'react-bootstrap';

function NavbarComponent({ bgColor, navbarContainerStyles }) {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleLogout = async () => {
    try {
      // SECURITE : vider le cache API puis purger le storage persistant pour
      // ne laisser aucune donnee du compte en cours deconnexion.
      dispatch(rxdApi.util.resetApiState());
      await dispatch(logout());
      await persistor.purge();
      console.log('Déconnexion');
      navigate(LOGIN_PATH);
      // Redirect or perform any additional actions after successful logout
    } catch (error) {
      console.error('Déconnexion échouée:', error);
      // Handle error if the logout fails
    }
  };

  const { clientID } = useParams();
  const handleParamClick = () => {
    if (clientID) {
      navigate(`/client/${clientID}/parametre/`);
    } else {
      navigate(PARAMETRES_CABINET);
    }
  };
  const userStatus = useSelector(getUser);
  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        padding: '0 20px',
        height: 60,
        backgroundColor: bgColor ? bgColor : '#F6F8F9',
        borderBottom: '1px solid rgba(0,0,0,0.1)',
        ...navbarContainerStyles,
      }}
    >
      <img
        src={logo}
        alt="Logo"
        style={{ width: '85px', marginRight: '11%' }} // Ajout de marginRight pour l'espacement
      />
      <div style={{ flex: 1 }}>
        <div className="searchBar d-none d-lg-block">
          <input
            style={{
              width: '100%',
              maxWidth: '600px',
              borderRadius: '15px',
              boxSizing: 'border-box',
            }}
            type="text"
            placeholder="Recherche dans Easy compta"
            className="form-control"
          />
        </div>
      </div>
      <div
        style={{ display: 'flex', alignItems: 'center', marginLeft: '20px' }}
      >
        <img
          src={Ellipse}
          alt="Profile"
          style={{
            width: '30px',
            height: '30px',
            borderRadius: '50%',
            marginRight: '10px',
          }}
        />
        <p style={{ margin: 0 }} className="me-3 me-lg-0">
          {/* Mouhamed */}
          {userStatus?.first_name} {userStatus?.last_name}
        </p>
        {/* <img
          onClick={handleLogout}
          src={Bell}
          className="imgs mx-2 d-none d-lg-block"
          style={{ Width: '18px', height: '18px' }}
        /> */}
        <img
          onClick={handleParamClick}
          src={Param}
          className="imgs mx-2 d-none d-lg-block"
          style={{ Width: '18px', height: '18px', cursor: 'pointer' }}
        />
        <img
          onClick={handleLogout}
          src={Logout}
          className="imgs mx-2 d-none d-lg-block"
          style={{ Width: '18px', height: '18px', cursor: 'pointer' }}
        />
        <NavDropdown
          title=""
          id="basic-nav-dropdown"
          className="d-lg-none d-block"
        >
          <NavDropdown.Item>
            <div className="searchBar">
              <input
                style={{
                  width: '100%',
                  maxWidth: '600px',
                  borderRadius: '15px',
                  boxSizing: 'border-box',
                }}
                type="text"
                placeholder="Recherche dans Easy compta"
                className="form-control"
              />
            </div>
          </NavDropdown.Item>
          <NavDropdown.Item>
            <img
              onClick={handleLogout}
              src={Bell}
              className="imgs mx-2"
              style={{ Width: '18px', height: '18px' }}
            />
          </NavDropdown.Item>
          <NavDropdown.Item>
            <img
              onClick={handleParamClick}
              src={Param}
              className="imgs mx-2"
              style={{ Width: '18px', height: '18px' }}
            />
          </NavDropdown.Item>
          <NavDropdown.Divider />
          <NavDropdown.Item>
            <img
              onClick={handleLogout}
              src={Logout}
              className="imgs mx-2"
              style={{ Width: '18px', height: '18px' }}
            />
          </NavDropdown.Item>
        </NavDropdown>
      </div>
    </div>
  );
}

// Add PropTypes validation for the props
NavbarComponent.propTypes = {
  // bgColor: PropTypes.string,
  navbarContainerStyles: PropTypes.object,
};

export default NavbarComponent;
